/**
 * Aanwezigheidskalender API Client (Spoor 2, Verlof MVP — Epic 4, Story 4.2)
 *
 * AD-9: `lib/<resource>Api.ts`-conventie, zelfde patroon als
 * `workScheduleApi.ts`. Consumeert `GET /api/v1/attendance-calendar`
 * (Story 4.1).
 */

import { apiRequest } from './api';
import type { AttendanceCalendarResponse } from '@functieloonhuis/shared';

export const aanwezigheidApi = {
  getCalendar: (van: string, tot: string) =>
    apiRequest<{ data: AttendanceCalendarResponse }>(`/attendance-calendar?van=${van}&tot=${tot}`),
};
